import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DemoProvider from './providers/DemoProvider';
import DemoShell from './layout/DemoShell';
import DemoGames from './components/DemoGames';
import DemoMuseMarket from './components/DemoMuseMarket';
import DemoMyMuses from './components/DemoMyMuses';
import DemoPackOpening from './components/DemoPackOpening';
import DemoGamePlayer from './components/DemoGamePlayer';

const DemoBoot: React.FC = () => {
  return (
    <DemoProvider>
      <DemoShell>
        <Routes>
          <Route index element={<Navigate to="/demo/games" replace />} />
          <Route path="games" element={<DemoGames />} />
          <Route path="market" element={<DemoMuseMarket />} />
          <Route path="mymuses" element={<DemoMyMuses />} />
          <Route path="pack-opening" element={<DemoPackOpening />} />
          <Route path="game/:gameId" element={<DemoGamePlayer />} />
          <Route path="*" element={<Navigate to="/demo/games" replace />} />
        </Routes>
      </DemoShell>
    </DemoProvider>
  );
};

export default DemoBoot;


